import React,{useEffect,useState} from "react";
import { useNavigate } from "react-router-dom";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../context/AuthContext";
import { toast } from "react-toastify";
import { apiGet, apiPost } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import moment from "moment";
import { useTranslation } from "react-i18next";

const InviteFriends = () => {
  const navigate = useNavigate();
      const { t } = useTranslation();
  function copy(text) {
    toast.success("Link Copied!");
    return window.navigator.clipboard.writeText(text);
  }
  const profileData = useContextSelector(AuthContext, (ctx) => ctx.profileData);
  const today = moment().format("YYYY-MM-DD");
  const monthStart = moment().startOf("month").format("YYYY-MM-DD");

  const [filter, setFilter] = useState({
    page: 1,
    limit: 100,
    fromPeriod: monthStart,
    toPeriod: today,
  });

  const [summary, setSummary] = useState({
    totalBonusEarn: 0,
    totalPlayerPL: 0,
  });

  const [matchData, setMatchData] = useState([]);

  const getMatchData = async () => {
    try {
      let requestFilter = { ...filter };

      if (filter.filterByDay) {
        if (filter.filterByDay === "today") {
          requestFilter.fromPeriod = today;
          requestFilter.toPeriod = today;
        }

        if (filter.filterByDay === "yesterday") {
          const yesterday = moment().subtract(1, "day").format("YYYY-MM-DD");
          requestFilter.fromPeriod = yesterday;
          requestFilter.toPeriod = yesterday;
        }
      }

      const { status, data } = await apiGet(
        apiPath.referralReport,
        requestFilter,
      );
      if (data?.success == true) {
        const results = data.results || [];

        setMatchData(results);

        const totals = results.reduce(
          (acc, item) => {
            acc.totalBonusEarn += Number(item?.earnd || 0);
            acc.totalPlayerPL += Number(item?.playerPL || 0);
            return acc;
          },
          { totalBonusEarn: 0, totalPlayerPL: 0 },
        );

        setSummary(totals);
      }
    } catch (error) {
      console.error("Referral report error:", error);
    }
  };
// console.log(summary);
  useEffect(() => {
    getMatchData();
  }, [filter]);
  return (
    <div
      id="mc-animate-container"
      className="v-base v-detail-base fade-enter-done"
    >
      <div className="invite-friends">
        <div className="invite-friends-root">
          <div className="mc-header-wrap">
            <div
              id="mc-header"
              className="mc-navbar-blue mc-inviteFriends mc-default-header am-navbar am-navbar-light"
            >
              <div
                onClick={() => navigate(-1)}
                className="am-navbar-left"
                role="button"
              >
                <span className="am-navbar-left-content">
                  <span className="return_icon">
                    <svg
                      style={{ color: "black" }}
                      className="am-icon am-icon-left am-icon-lg"
                    >
                      <use xlinkHref="#left" />
                    </svg>
                  </span>
                </span>
              </div>
              <div className="am-navbar-title">Invite Friends</div>
              <div className="am-navbar-right" />
            </div>
            <div className="am-whitespace am-whitespace-sm mc-whitespace" />
          </div>
          <div className="am-tabs am-tabs-top invite-tab">
            <div role="tablist" className="am-tabs-bar" tabIndex={0}>
              <div className="am-tabs-nav-container am-tabs-nav-swipe-container am-tabs-nextpage">
                <div className="am-tabs-nav-wrap">
                  <div
                    className="am-tabs-nav-swipe"
                    style={{
                      "touch-action": "pan-y",
                      "-webkit-user-select": "none",
                      "-moz-user-select": "none",
                      "-ms-user-select": "none",
                      "user-select": "none",
                      "-webkit-transform": "translate3d(0px, 0px, 0px)",
                      "-ms-transform": "translate3d(0px, 0px, 0px)",
                      transform: "translate3d(0px, 0px, 0px)",
                    }}
                  >
                    <div className="am-tabs-nav">
                      <div
                        className="am-tabs-ink-bar am-tabs-ink-bar-animated"
                        style={{
                          display: "block",
                          "-webkit-transform": "translate3d(0px, 0px, 0px)",
                          "-ms-transform": "translate3d(0px, 0px, 0px)",
                          transform: "translate3d(0px, 0px, 0px)",
                          width: "90px",
                        }}
                      />
                      <div
                        role="tab"
                        aria-disabled="false"
                        aria-selected="true"
                        className="am-tabs-tab am-tabs-tab-active"
                        style={{
                          "-webkit-flex-basis": "33.3333%",
                          "-ms-flex-basis": "33.3333%",
                          "flex-basis": "33.3333%",
                        }}
                      >
                        <span className="am-badge">
                          {/* react-text: 4035 */}Overview{/* /react-text */}
                        </span>
                      </div>
                      <div
                        role="tab"
                        aria-disabled="false"
                        aria-selected="false"
                        className="am-tabs-tab"
                        style={{
                          "-webkit-flex-basis": "33.3333%",
                          "-ms-flex-basis": "33.3333%",
                          "flex-basis": "33.3333%",
                        }}
                      >
                        <span className="am-badge">
                          {/* react-text: 4038 */}Rewards{/* /react-text */}
                        </span>
                      </div>
                      <div
                        role="tab"
                        aria-disabled="false"
                        aria-selected="false"
                        className="am-tabs-tab"
                        style={{
                          "-webkit-flex-basis": "33.3333%",
                          "-ms-flex-basis": "33.3333%",
                          "flex-basis": "33.3333%",
                        }}
                      >
                        <span className="am-badge">
                          {/* react-text: 4041 */}Incomes{/* /react-text */}
                        </span>
                      </div>
                      <div
                        role="tab"
                        aria-disabled="false"
                        aria-selected="false"
                        className="am-tabs-tab"
                        style={{
                          "-webkit-flex-basis": "33.3333%",
                          "-ms-flex-basis": "33.3333%",
                          "flex-basis": "33.3333%",
                        }}
                      >
                        <span className="am-badge">
                          {/* react-text: 4044 */}Records{/* /react-text */}
                        </span>
                      </div>
                      <div
                        role="tab"
                        aria-disabled="false"
                        aria-selected="false"
                        className="am-tabs-tab"
                        style={{
                          "-webkit-flex-basis": "33.3333%",
                          "-ms-flex-basis": "33.3333%",
                          "flex-basis": "33.3333%",
                        }}
                      >
                        <span className="am-badge">
                          {/* react-text: 4047 */}Invited List
                          {/* /react-text */}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="am-tabs-content am-tabs-content-no-animated">
              <div
                role="tabpanel"
                aria-hidden="false"
                className="am-tabs-tabpane am-tabs-tabpane-active"
              >
                <div className="invite-friends-container">
                  <div className="container-wrap">
                    <div className="invite-friends-link">
                      <div className="link-top-title">
                        Share to your friends
                      </div>
                      <div className="share-content-wrap">
                        <div style={{width:"100%"}} className="share-title">Share to your friends</div>
                        {/* <div className="share-group">
                          <div className="share-btn facebook-btn" />
                          <div className="share-btn sms-btn" />
                          <div className="share-btn twitter-btn" />
                          <div className="share-btn telegram-btn" />
                          <div className="share-btn whatsapp-btn" />
                          <div className="share-btn link" />
                        </div> */}
                      </div>
                      <div className="invite-link-wrap">
                        <svg className="am-icon am-icon-share-link_b24bce29 am-icon-md">
                          <use xlinkHref="#share-link_b24bce29" />
                        </svg>
                        <div className="link-url">
                          {process.env.REACT_APP_URL}
                          auth/register/?referral_code=
                          {profileData?.referalCode}
                        </div>
                        <div
                          onClick={() =>
                            copy(`${process.env.REACT_APP_URL}auth/register/?referral_code=
                          ${profileData?.referalCode}`)
                          }
                          className="link-copy"
                        >
                          <span>Copy</span>
                        </div>
                      </div>
                    </div>
                   <div
              _ngcontent-serverapp-c1696643091=""
              className="referral-code-panel__btn-wrap ng-tns-c1696643091-17"
              style={{ margin: `12px` }}
            >
              <div
                _ngcontent-serverapp-c1696643091=""
                className="referral-code-panel__btn referral-code-panel__btn-link ng-tns-c1696643091-17"
              >
                Total Earn:
                <span
                  className={
                    summary?.totalBonusEarn >= 0
                      ? "text-green"
                      : "text-red"
                  }
                  style={{ marginLeft: "5px" }}
                >
                  {Math.abs(summary?.totalBonusEarn ?? 0).toFixed(2) ||
                    0.0}
                </span>
              </div>
              {/* <div
                      onClick={() => handleShare()}
                      _ngcontent-serverapp-c1696643091=""
                      className="referral-code-panel__btn ng-tns-c1696643091-17 ng-star-inserted"
                      style={{}}
                    >
                      Ongoing commission:{" "}
                      <span style={{ marginLeft: "5px" }}>
                        {Math.abs(
                          ((3 / 100) * summary?.totalPlayerPL)?.toFixed(2),
                        ) || 0.0}
                      </span>
                    </div> */}
            </div>

            <div
              style={{
                display: "flex",

                alignItems: "center",
                justifyContent: "space-evenly",
              }}
            >
              <input
                className="small_form_control"
                onChange={(e) =>
                  setFilter({
                    ...filter,
                    fromPeriod: e.target.value,
                  })
                }
                style={{
                  background: "#ffb80c",
                  border: "none",
                  padding: "5px",
                  borderRadius: "5px",
                  width: "40%",
                }}
                max={new Date().toISOString().split("T")[0]}
                value={filter.fromPeriod}
                type="date"
              />
              <input
                className="small_form_control"
                onChange={(e) =>
                  setFilter({
                    ...filter,
                    toPeriod: e.target.value,
                  })
                }
                style={{
                  background: "#ffb80c",
                  border: "none",
                  padding: "5px",
                  borderRadius: "5px",
                  width: "40%",
                }}
                min={
                  filter?.fromPeriod
                    ? new Date(filter?.fromPeriod)
                      .toISOString()
                      .split("T")[0]
                    : new Date()
                }
                max={new Date().toISOString().split("T")[0]}
                value={filter.toPeriod}
                type="date"
              />
            </div>

            <ul
              style={{ padding: "10px 0", marginTop: '10px' }}
              _ngcontent-serverapp-c221247831
              className="cricket-list-content ng-tns-c221247831-105"
            >
              {matchData?.length > 0 ? (
                matchData?.map((res) => {
                  return (
                    <li
                      style={{ color: "white" }}
                      _ngcontent-serverapp-c3238644402
                      className={`accordion-wrap ng-tns-c3238644402-106 ng-star-inserted`}
                    >
                      <div
                        _ngcontent-serverapp-c3238644402
                        // style={{ padding: "0" }}
                        className={`accordion-header ng-tns-c3238644402-106 ng-star-inserted`}
                      >
                        <div
                          style={{ display: "block" }}
                          _ngcontent-serverapp-c3238644402
                          className="main-info ng-tns-c3238644402-106"
                        >
                          <div
                            _ngcontent-serverapp-c3238644402
                            className="title ng-tns-c3238644402-106"
                          >
                            <span
                              _ngcontent-serverapp-c3238644402
                              className="category-type ng-tns-c3238644402-106"
                            >
                              {res.username}
                            </span>
                          </div>
                        </div>
                        <div
                          _ngcontent-serverapp-c3238644402
                          className="betting-info ng-tns-c3238644402-106"
                        >
                          <div
                            _ngcontent-serverapp-c3238644402
                            className="avg-odds ng-tns-c3238644402-106"
                          >
                            <svg
                              _ngcontent-serverapp-c3238644402
                              className="item-icon ng-tns-c3238644402-106"
                            >
                              <circle
                                _ngcontent-serverapp-c3238644402
                                cx={9}
                                cy={9}
                                r={9}
                                className="circle ng-tns-c3238644402-106"
                              />
                              <use
                                _ngcontent-serverapp-c3238644402
                                href={"/assets/Other/icon-odds.svg"}
                                className="icon ng-tns-c3238644402-106"
                              />
                            </svg>
                            <strong _ngcontent-serverapp-c3238644402>
                              {Math.abs(res.earnd?.toFixed(2)) || 0}
                            </strong>
                            <span
                              _ngcontent-serverapp-c3238644402
                              className="ng-tns-c3238644402-106"
                            >
                              Bonus Earned
                            </span>
                          </div>

                          <div
                            _ngcontent-serverapp-c3238644402
                            className="avg-odds ng-tns-c3238644402-106"
                          >
                            <svg
                              _ngcontent-serverapp-c3238644402
                              className="item-icon ng-tns-c3238644402-106"
                            >
                              <circle
                                _ngcontent-serverapp-c3238644402
                                cx={9}
                                cy={9}
                                r={9}
                                className="circle ng-tns-c3238644402-106"
                              />
                              <use
                                _ngcontent-serverapp-c3238644402
                                href={"/assets/Other/icon-odds.svg"}
                                className="icon ng-tns-c3238644402-106"
                              />
                            </svg>
                            <strong _ngcontent-serverapp-c3238644402>
                              {Math.sign(res.playerPL) == 1 ? (
                                Math.abs(res.playerPL) != 0 ? (
                                  <span
                                    style={{ fontSize: "unset" }}
                                    className="text-success"
                                  >
                                    {Math.abs(res.playerPL?.toFixed(2))}
                                  </span>
                                ) : (
                                  0.0
                                )
                              ) : Math.abs(res.playerPL) != 0 ? (
                                <span
                                  style={{ fontSize: "unset" }}
                                  className="text-danger"
                                >
                                  {Math.abs(res.playerPL?.toFixed(2))}
                                </span>
                              ) : (
                                0.0
                              )}
                            </strong>
                            <span
                              _ngcontent-serverapp-c3238644402
                              className="ng-tns-c3238644402-106"
                            >
                              P&L
                            </span>
                          </div>
                        </div>
                      </div>
                    </li>
                  );
                })
              ) : (
                <mcd-no-data
                  _nghost-serverapp-c3013389467
                  className="ng-star-inserted"
                >
                  <div
                    _ngcontent-serverapp-c3013389467
                    className="no-result"
                  >
                    <div _ngcontent-serverapp-c3013389467 className="pic">
                      <img
                        _ngcontent-serverapp-c3013389467
                        alt="no-data"
                        src="/assets/NewImages/no-data.webp?v=1776751585885&source=mcdsrc"
                        loading="lazy"
                      />
                    </div>
                    <div
                      _ngcontent-serverapp-c3013389467
                      className="text ng-star-inserted"
                    >
                      {" "}
                      {t("NoData")}{" "}
                    </div>
                  </div>
                </mcd-no-data>
              )}
            </ul>
                    {/*  */}
                    {/* react-empty: 4052 */}
                  </div>
                </div>
              </div>
              <div
                role="tabpanel"
                aria-hidden="true"
                className="am-tabs-tabpane am-tabs-tabpane-inactive"
              />
              <div
                role="tabpanel"
                aria-hidden="true"
                className="am-tabs-tabpane am-tabs-tabpane-inactive"
              />
              <div
                role="tabpanel"
                aria-hidden="true"
                className="am-tabs-tabpane am-tabs-tabpane-inactive"
              />
              <div
                role="tabpanel"
                aria-hidden="true"
                className="am-tabs-tabpane am-tabs-tabpane-inactive"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InviteFriends;
